const isAsinSearch = tags => {
  return Array.isArray(tags) && tags?.length
}

export const getAllVariantsValue = (tags, allVariantsState) => {
  return isAsinSearch(tags) ? allVariantsState : false
}
